module.exports = "/* You can add global styles to this file, and also import other style files */\n\n\nbody {\n  background: radial-gradient(#dbdce0 15%, transparent 16%) 0 0,radial-gradient(#dbdce0 15%, transparent 16%) 8px 8px,radial-gradient(rgba(255,255,255,0.1) 15%, transparent 20%) 0 1px,radial-gradient(rgba(255,255,255,0.1) 15%, transparent 20%) 8px 9px;\n  background-color: #dfe0e3;\n  background-size: 16px 16px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles